import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationSafetyService {
  init() {
    // Block right-click context menu
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });

    // Block middle-click (mouse button 1)
    document.addEventListener('mousedown', (e) => {
      if (e.button === 1) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    // Block Cmd/Ctrl+click on links
    document.addEventListener(
      'click',
      (e: MouseEvent) => {
        if (e.metaKey || e.ctrlKey) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true,
    );
  }
}
